/* Main auto-generated by npm run generator */
import { makeStyles, Theme } from "@material-ui/core"
import clsx from "clsx"
import PortalBreadCrumbs from "components/molecules/PortalBreadCrumbs"
import TopBar from "components/organisms/Layout/TopBar"
import { observer } from "mobx-react"
import React, { CSSProperties } from "react"
import { BrowserRouter } from "react-router-dom"
import { PortalRouter } from "Router"

/* this is really a page */
interface MainLayoutProps {
    className?: string
    style?: CSSProperties
    children?: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => ({
    mainLayout: {
        background: theme.palette.common.white,
        padding: theme.spacing(2, 4),
        maxWidth: 1440,
        margin: "0 auto",
        display: "grid",
    },
}))

const MainLayout: React.FC<MainLayoutProps> = (props) => {
    const classes = useStyles()
    const className = clsx(classes.mainLayout, props.className)

    return (
        <div className={className}>
            <BrowserRouter>
                <TopBar />
                <PortalBreadCrumbs />
                <PortalRouter />
            </BrowserRouter>
        </div>
    )
}

export default observer(MainLayout)
